@if (data) {
  <fui-rows [label]="'Card Verification Rules'">
    <fui-content-layout-header-control slot="after">
      @if (!editing && model.canEdit()) {
        <fui-link-button [title]="'edit'"
        (click)="edit()"></fui-link-button>
      }
    </fui-content-layout-header-control>
    @if (data) {
      <fui-row>
        <fui-two-columns>
          <fui-column>
            <fui-numeric-control
              [label]="'fhm.card-verification.threshold'"
              [placeholder]="'fhm.common.label.no-label'"
              [decimals]="2"
              [ngModelOptions]="{standalone: true}"
              [disabled]="!editing"
            [(ngModel)]="data.verificationThreshold"></fui-numeric-control>
          </fui-column>
          <fui-column>
            <fui-numeric-control
              [label]="'fhm.card-verification.fee'"
              [placeholder]="'fhm.common.label.no-label'"
              [decimals]="2"
              [ngModelOptions]="{standalone: true}"
              [disabled]="!editing"
            [(ngModel)]="data.verificationFee"></fui-numeric-control>
          </fui-column>
        </fui-two-columns>
      </fui-row>
      @if (editing && !model.draft) {
        <fui-row>
          <fhm-action-buttons>
            <fhm-remove-button [title]="'fhm.common.button.cancel'"
            (clicked)="cancelEdit()"></fhm-remove-button>
            <fhm-provision-button [title]="'fhm.common.button.save'"
            (clicked)="save()"></fhm-provision-button>
          </fhm-action-buttons>
        </fui-row>
      }
    }
  </fui-rows>
}


